import React from 'react';
import styled from 'styled-components';
import { Box, TextField } from '@material-ui/core';

const EditableTextComponent = styled(TextField)`
  .Mui-disabled {
    color: black;
  }
`;

const EditableText = ({
  value = '',
  onChange = () => {},
  isEditing = false,
  placeholder,
  labelTitle,
  labelActionIcon, // optional: pass in a <LabelActionIcon /> component
  InputProps,
  InputLabelProps,
}) => {
  const label = (
    <Box whiteSpace="nowrap">
      <>{labelTitle}</>
      {labelActionIcon}
    </Box>
  );

  return (
    <EditableTextComponent
      disabled={!isEditing}
      value={value}
      onChange={onChange}
      placeholder={placeholder}
      // during editing, the labelTitle moves from above the input to below
      label={!isEditing && label}
      helperText={isEditing && labelTitle}
      InputProps={{
        disableUnderline: !isEditing,
        ...InputProps,
      }}
      InputLabelProps={{
        shrink: true,
        ...InputLabelProps,
      }}
    />
  );
};

export default EditableText;
